import React from "react";

function ChaseBankIcon() {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M12.125 5.75H12M5 9V19M9 9V19M15 9V19M19 9V19M12.25 5.75C12.25 5.8163 12.2237 5.87989 12.1768 5.92678C12.1299 5.97366 12.0663 6 12 6C11.9337 6 11.8701 5.97366 11.8232 5.92678C11.7763 5.87989 11.75 5.8163 11.75 5.75C11.75 5.6837 11.7763 5.62011 11.8232 5.57322C11.8701 5.52634 11.9337 5.5 12 5.5C12.0663 5.5 12.1299 5.52634 12.1768 5.57322C12.2237 5.62011 12.25 5.6837 12.25 5.75Z"
        stroke="black"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M21.3518 9H2.64775C2.50734 8.99801 2.37126 8.95108 2.25946 8.86609C2.14767 8.78111 2.06605 8.66254 2.02657 8.52777C1.98709 8.393 1.99183 8.24913 2.04009 8.11726C2.08836 7.98538 2.17761 7.87244 2.29475 7.795L8.72975 3.565C10.3168 2.522 11.1098 2 11.9998 2C12.8898 2 13.6828 2.522 15.2698 3.565L21.7048 7.795C21.8212 7.87283 21.9098 7.9858 21.9577 8.11748C22.0055 8.24916 22.0101 8.39266 21.9707 8.5271C21.9313 8.66155 21.85 8.77991 21.7387 8.86497C21.6274 8.95002 21.4918 8.99733 21.3518 9ZM21.0398 20.293L20.3518 19.586C20.0708 19.296 19.9298 19.152 19.7518 19.076C19.5718 19 19.3738 19 18.9758 19H5.02375C4.62575 19 4.42675 19 4.24875 19.076C4.06875 19.152 3.92875 19.296 3.64875 19.586L2.95975 20.293C2.25375 21.019 1.89975 21.383 2.02475 21.691C2.14875 22 2.64875 22 3.64775 22H20.3518C21.3518 22 21.8518 22 21.9748 21.691C22.0998 21.383 21.7458 21.019 21.0398 20.293Z"
        stroke="black"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

export default ChaseBankIcon;
